<script setup lang="ts">
import { computed } from 'vue';
import { Button } from '@/storybook';

interface ComingSoonIntegration {
  name: string;
  description: string;
}

interface Props {
  integration: ComingSoonIntegration;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  requestIntegration: [name: string];
}>();

// Generate slug from integration name for consistent data-testid attributes
const integrationSlug = computed(() => {
  return props.integration.name.toLowerCase().replace(/\s+/g, '-');
});

const handleRequestClick = () => {
  emit('requestIntegration', props.integration.name);
};
</script>

<template>
  <div
    class="flex items-start gap-6 p-8 bg-white dark:bg-zinc-800 rounded-[10px] border border-amber-500 transition-all duration-200 hover:shadow-lg"
    :data-testid="`coming-soon-card-${integrationSlug}`"
  >
    <div class="flex-grow">
      <h3
        class="text-xl font-semibold text-slate-900 dark:text-zinc-300 mb-2 flex flex-col items-start gap-2"
        :data-testid="`integration-name-${integrationSlug}`"
      >
        <span class="inline-block bg-amber-500 text-white text-xs font-medium px-2 py-1 rounded-md lowercase">Coming soon</span>
        <span class="block">{{ integration.name }}</span>
      </h3>
      <p class="text-sm text-slate-600 dark:text-zinc-400 leading-6 mb-4" :data-testid="`integration-description-${integrationSlug}`">
        {{ integration.description }}
      </p>
      <div class="mt-4">
        <Button
          type="solid"
          variant="blue"
          size="regular"
          @click="handleRequestClick"
          :data-testid="`request-integration-${integrationSlug}`"
          text="Request integration"
        />
      </div>
    </div>
  </div>
</template>
